module.exports = __webpack_public_path__ + "img/up-convex.d6f28f49.svg";